import classes from "../styles/home.module.css";
import React from "react";
import Layout from "../components/Layout";
import { StylesProvider } from "@material-ui/core/styles";
import { graphql } from "gatsby";
import Img from "gatsby-image/withIEPolyfill";
import { Helmet } from "react-helmet";

/// https://github.com/gatsbyjs/gatsby/issues/14988
// TODO: Have to have two Img elements and use CSS to hide one on different media due to issue:
// https://github.com/gatsbyjs/gatsby/pull/24811

const title = "Avenue Barber | Oak Bay Barbershop, Victoria BC";
const description =
  "Quality haircuts at a reasonable price in a nice, clean and friendly atmosphere.";

export default function Home({ data, location }) {
  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: "en",
        }}
      >
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:type" content="website" />

        <meta property="og:title" content={title} />

        <meta property="og:description" content={description} />

        {/* <meta property="og:image" content="LINK TO THE IMAGE FILE" /> */}

        {/* <meta property="og:url" content="PERMALINK" /> */}

        <meta property="og:site_name" content="Avenue Barber" />
        <link rel="canonical" href="https://avenuebarber.ca" />
      </Helmet>
      <StylesProvider injectFirst>
        <Layout data={data} location={location}>
          <div className={classes.imgContainer}>
            <Img
              className={classes.desktopImage}
              fluid={data.desktopCoverImage.childImageSharp.fluid}
            />
            <Img
              className={classes.image}
              fluid={data.mobileCoverImage.childImageSharp.fluid}
            />
          </div>
        </Layout>
      </StylesProvider>
    </>
  );
}

export const query = graphql`
  query {
    mobileCoverImage: file(relativePath: { eq: "home-photo-main-mobile.png" }) {
      childImageSharp {
        fluid(maxWidth: 767, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
    desktopCoverImage: file(
      relativePath: { eq: "home-photo-main-desktop.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 1100, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
    mobileLogo: file(relativePath: { eq: "logo-mobile.png" }) {
      childImageSharp {
        fixed(width: 96, quality: 100) {
          ...GatsbyImageSharpFixed_tracedSVG
        }
      }
    }
    desktopLogo: file(relativePath: { eq: "logo-desktop.png" }) {
      childImageSharp {
        fixed(width: 256, quality: 100) {
          ...GatsbyImageSharpFixed_tracedSVG
        }
      }
    }
  }
`;
